import { useMemo } from "react";
import Select from "../common/components/Select";
import { useJobStatuses } from "../reducers/jobStatusSlice"
import { useTranslation } from "react-i18next";

const JobStatusDropdown = ({ value, placeholder, isSearch, ...props }) => {
    const { t } = useTranslation();
    const statuses = useJobStatuses();

    const displayStatuses = useMemo(() => {
        if (value === 'Closed') {
            return ['Closed'];
        }
        let displayStatuses = statuses.filter(s => isSearch || s.selectable === undefined || s.selectable === true).map(s => s.name);
        if (displayStatuses.every(s => s !== value)) {
            displayStatuses.push(value);
        }
        return displayStatuses;
    }, [statuses, isSearch, value]);

    return <Select value={value} placeholder={placeholder ?? t('status_one')} {...props} options={displayStatuses}></Select>
}

export default JobStatusDropdown;